import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

interface CenteredCircularProgressProps {
  circularProgressProps?: CircularProgressProps;
  minHeight?: string;
}

const CenteredCircularProgress = ({
  circularProgressProps = {
    size: 50,
    color: 'primary',
  },
  minHeight = '100%',
}: CenteredCircularProgressProps) => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
    <CircularProgress {...circularProgressProps} />
  </Box>
);

export { CenteredCircularProgress };
